import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "../../shared/components";

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Unhandled admin panel error", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="grid min-h-dvh place-items-center bg-background px-5 py-10 text-foreground">
        <section className="w-full max-w-lg rounded-lg border bg-card p-6 sm:p-8">
          <span className="mb-5 grid size-12 place-items-center rounded-lg bg-red-500/10 text-red-400">
            <AlertTriangle aria-hidden="true" className="size-6" />
          </span>
          <p className="text-xs font-medium text-muted-foreground">Erro inesperado</p>
          <h1 className="mt-2 text-2xl font-semibold">Não foi possível carregar esta página</h1>
          <p className="mt-3 text-sm leading-6 text-muted-foreground">
            Recarregue a página. Se o problema continuar, entre em contato com o suporte.
          </p>
          <Button className="mt-6" onClick={() => window.location.reload()}>
            <RefreshCw aria-hidden="true" className="size-4" />
            Recarregar
          </Button>
        </section>
      </main>
    );
  }
}
